module.exports = __webpack_public_path__ + "img/logo1.056af77f.svg";